import { RegionalUserData } from '@graft/nuget-gc.webportals.regionalusers'

import type { RegionalUser } from '../user.interface'

type RegionalUserDataConstructor = new (
  userId: string,
  userEmail: string,
  firstname: string,
  lastname: string,
  createdAt?: string,
  createdBy?: string,
  updatedAt?: string,
  updatedBy?: string
) => RegionalUserData

const RegionalUserDataCtor = RegionalUserData as unknown as RegionalUserDataConstructor

const EMPTY_AUDIT_FIELD = ''

export const buildRegionalUserData = ({ userId, userEmail, firstname, lastname }: RegionalUser): RegionalUserData =>
  new RegionalUserDataCtor(
    userId,
    userEmail,
    firstname,
    lastname,
    EMPTY_AUDIT_FIELD,
    EMPTY_AUDIT_FIELD,
    EMPTY_AUDIT_FIELD,
    EMPTY_AUDIT_FIELD
  )
